import React from 'react';
import AreaButtons from '../dashboard/AreaButtons';
import { PageHeader } from '../ui';

const OPTIONS = [['a', 'Esempio 1 · Pillole', 'Bottoni a pillola con icona colorata, su una riga.'],
  ['b', 'Esempio 2 · Tessere icona', 'Piccole tessere quadrate con icona e nome, bordo colorato in alto.'],
  ['c', 'Esempio 3 · Barra unica', 'Una sola barra divisa in 4, con una linea di colore per area.'],
  ['d', 'Esempio 4 · Chip scuri', 'Chip scuri con icona oro e riflesso al passaggio del mouse.']];

export default function AreaButtonsPreviewPage() {
  return (
    <div data-testid="area-buttons-preview-page">
      <PageHeader kicker="Panoramica" title="Scegli i bottoni delle 4 aree" />
      {OPTIONS.map(([v, t, d]) => (
        <section key={v} className="mb-10" data-testid={`area-variant-${v}`}>
          <p className="font-semibold mb-1">{t}</p>
          <p className="text-sm text-[#7A7F87] mb-4">{d}</p>
          <AreaButtons variant={v} testPrefix={`variant-${v}`} />
        </section>
      ))}
    </div>
  );
}
